
export enum CommandActionEnum {
    Create = 1,
    Modify = 2,
    Delete = 3,
    Trigger = 4
}
